import { feedEventDisplayTimestamp } from "@/features/feed/feedEventTime";
import type { FeedEvent } from "@/types/feed";

export function feedReviewToastTitle(count: number): string {
  return count === 1
    ? "Marked as reviewed"
    : `${count} events marked as reviewed`;
}

export function snapshotFeedEvents(
  events: FeedEvent[],
  ids: string[],
): FeedEvent[] {
  const idSet = new Set(ids);
  return events.filter((event) => idSet.has(event.id));
}

export function applyFeedReview(
  events: FeedEvent[],
  ids: string[],
  options: { removeFromList: boolean; reviewedAt: string },
): FeedEvent[] {
  const idSet = new Set(ids);
  if (options.removeFromList) {
    return events.filter((event) => !idSet.has(event.id));
  }
  return events.map((event) =>
    idSet.has(event.id)
      ? { ...event, is_reviewed: true, reviewed_at: options.reviewedAt }
      : event,
  );
}

/** Re-insert or un-stamp events captured before {@link applyFeedReview}. */
export function restoreFeedReview(
  events: FeedEvent[],
  snapshot: FeedEvent[],
): FeedEvent[] {
  if (snapshot.length === 0) return events;
  const snapById = new Map(snapshot.map((event) => [event.id, event]));
  const existing = new Set(events.map((event) => event.id));
  const next = events.map((event) => snapById.get(event.id) ?? event);
  const missing = snapshot.filter((event) => !existing.has(event.id));
  if (missing.length === 0) return next;
  return [...next, ...missing].sort(
    (a, b) => feedEventDisplayTimestamp(b) - feedEventDisplayTimestamp(a),
  );
}
